export default __webpack_public_path__ + "static/lifetime-logoanimation-533165779c2b2d54691ace261bc8594e.gif";